import React, { useMemo, useState } from 'react'
import { useSpring, animated } from '@react-spring/web'
import './product-image.scss'

interface IProductImageProps {
  tags: string[]
  imageUrl: string
  secondaryImage?: string
  onClick: () => void
  baseClassName: string
  cart?: boolean
}

export const ProductImage = ({ tags = [], imageUrl, onClick, baseClassName, secondaryImage, cart }: IProductImageProps): JSX.Element => {
  const filteredTags = useMemo(
    () =>
      [...tags].filter(
        (tag: string) => tag.match(/^(.*-new)/g) // get '-new' tag
      ),
    [tags]
  )

  const renderTag = useMemo(() => {
    if (filteredTags.length > 0) {
      const newTagArray = filteredTags[0].split('-')
      const tagText = newTagArray[newTagArray.length - 1]

      return <span className={`${baseClassName}__product-tag`}>{tagText}</span>
    } else {
      return null
    }
  }, [filteredTags, baseClassName])

  return (
    <div className={`${baseClassName}__image-container`}>
      {/* <div onClick={onClick} className={`${baseClassName}__image`} style={{ backgroundImage: `url(${imageUrl})` }} /> */}
      <ImageReveal imageUrl={imageUrl} baseClassName={baseClassName} secondImageUrl={secondaryImage} onClick={onClick} cart={cart} />
      {renderTag}
    </div>
  )
}

interface IImageRevealProps {
  imageUrl: string
  baseClassName: string
  secondImageUrl?: string
  onClick: () => void
  cart?: boolean
}

const ImageReveal: React.FC<IImageRevealProps> = ({ imageUrl, baseClassName, secondImageUrl, cart=false, onClick }) => {
  const [isHovered, setIsHovered] = useState(false)

  const { opacity } = useSpring({
    opacity: isHovered ? 1 : 0,
    config: { duration: 300 }
  })

  if (!secondImageUrl) {
    return (
      <div className={`${baseClassName}__image-reveal-container card__media`} onClick={onClick}>
        <div className={`${cart ? '' : 'product-image__media'} media media--transparent media--hover-effect`} style={{ minHeight: cart ? 'auto' : '220px' }}>
          <img loading='lazy' className={`${baseClassName}__image_1`} src={imageUrl} alt='Product' />
        </div>
      </div>
    )
  }

  return (
    <div
      className={`${baseClassName}__image-reveal-container card__media`}
      onMouseEnter={() => setIsHovered(true)}
      onMouseLeave={() => setIsHovered(false)}
      onClick={onClick}
    >
      <div className='product-image__media media media--transparent media--hover-effect' style={{ minHeight: '243px' }} >
        <img className={`image_1`} src={imageUrl} alt='Product'/>
      </div>
      {secondImageUrl && (
        <animated.img
          src={secondImageUrl}
          className={`image_2`}
          alt='Product Hover'
          style={{
            position: 'absolute',
            top: 0,
            left: 0,
            opacity: opacity.to((opacity) => opacity)
          }}
        />
      )}
    </div>
  )
}
